import { useEffect, useState } from "react";
import tempPic from "./../../../../../asset/image/default.png";
import {useTranslation} from "react-i18next";


export default function User({ data, setMembersGroup, membersGroup, active }) {

  const [check, setCheck] = useState(false);
  const [prevCheck, setPrevCheck] = useState(active)
  const {t} = useTranslation()

  const HandleCheckBox = () => {
    setCheck(!check);
    setPrevCheck(false);
  };

  const addToGroup = () => {

    let result = membersGroup?.map((item) => item.company_club).includes(data.company_club || data.id)

    if (check && result === false) {
      setMembersGroup([...membersGroup, {
        "company_club": data?.id || data?.company_club,
      }]);
    }

    if (check === false) {
      setMembersGroup((items) => items.filter((item) => item.company_club !== data.id))
    }
  }

  const changeCheckedItem = () => {
    if (prevCheck === true) {
      setCheck(true)
    }
    if (prevCheck === false) {
      setMembersGroup((items) => items.filter((item) => item.company_club !== data.company_club))
    }
  }

  useEffect(() => {
    addToGroup()
  }, [check])

  useEffect(() => {
    changeCheckedItem()
  }, [prevCheck])


  return (
    <div className="table-row" style={check || prevCheck ? { background: "#F1F5FF" } : {}}>
      <div>
        <div className={check || prevCheck ? "selected" : ""} onClick={HandleCheckBox}>
          <div></div>
        </div>
      </div>
      <div>
        <div>
          <img src={tempPic} alt="temporary" />
        </div>
        <div>
          <div>{check || prevCheck ? t('Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.User.Active') :
            t('Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.User.DeActive')}
          </div>
          <div>{!active && data.user.first_name + " " + data.user.last_name}</div>
          {
            active && (<div>{data.first_name + " " + data.last_name}</div>)
          }
        </div>
      </div>
    </div>
  );
}
